import React, { useState, useRef, useEffect } from 'react';
import {
  List,
  ApiServices,
  ApiServiceTypes,
  ListFilterHeaderItem,
  ListHeaderItem,
  useTranslation,
  ListHeaderFilter,
  toFixed,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { TranslationKeys } from '../../../enums';
import { StatisticItem } from '../../../components/common/statisticts';

const lastRoundValues = [100, 200, 500];

export const StatisticsWr = observer(() => {
  const t = useTranslation();
  const { gameTypeId } = gameConfigStore;
  const [lastRound, setLastRound] = useState(lastRoundValues[0]);
  const [statistics, setStatistics] = useState({});
  const prevValueRef = useRef(null);

  useEffect(async () => {
    const {
      data: { result },
    } = await ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({
      gameTypeId,
      take: lastRound,
    });

    if (result) {
      setStatistics(result);
    }

    return () => setStatistics({});
  }, []);

  useEffect(async () => {
    if (!statistics.length && lastRound !== prevValueRef.current) {
      prevValueRef.current = lastRound;
      const {
        data: { result },
      } = await ApiServices.get(ApiServiceTypes.StatisticsService).getStatistics({
        gameTypeId,
        take: lastRound,
      });
      if (result) {
        setStatistics(result);
      }
    }
  }, [lastRound, statistics]);

  return (
    <List>
      <ListHeaderFilter style={{ justifyContent: 'space-between' }}>
        <div className={'d-f-custom'}>
          <ListHeaderItem>{t(TranslationKeys.LastRounds)}</ListHeaderItem>
          {lastRoundValues.map((item) => (
            <ListFilterHeaderItem
              key={item}
              isActive={lastRound === item}
              onClick={() => setLastRound(item)}
            >
              {item}
            </ListFilterHeaderItem>
          ))}
        </div>
      </ListHeaderFilter>
      <div className='bottom-of-lists-wrapper'>
        <div className='scrollable-container'>
          <div className='statistics-block-wheel'>
            {Object.keys(statistics).map((item) => (
              <StatisticItem key={item} candy={item} percentage={toFixed(statistics[item], 2)} />
            ))}
          </div>
        </div>
      </div>
    </List>
  );
});
